import React from "react";
import { useNavigate } from "react-router";
import { GenericError } from "src/components/Feedback/GenericError";
import { Loading } from "src/components/Feedback/Loading";
import { NotFound } from "src/components/Feedback/NotFound";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import { useOrganization } from "src/hooks/useOrganization";
import * as Url from "src/services/url/OrgAdmin";
import * as RD from "src/types/remoteData";
import { useMyProfileHomePage } from "./useMyProfileHomePage";

export * from "./Notifications";
export * from "./Security";

export const Home = () => {
  const organizationRD = useOrganization();
  const navigate = useNavigate();
  const myProfileRD = useMyProfileHomePage();

  const remoteData = React.useMemo(() => {
    return RD.toTuple(myProfileRD, organizationRD);
  }, [myProfileRD, organizationRD]);

  React.useEffect(() => {
    remoteData.do(([myProfile, organization]) => {
      if (myProfile === "redirect-to-mfa") {
        navigate(Url.UserProfile.security(organization), {
          replace: true,
        });
      } else if (myProfile === "redirect-to-notification") {
        navigate(Url.UserProfile.notifications(organization), {
          replace: true,
        });
      }
    });
  }, [navigate, remoteData]);

  return (
    <RemoteDataView
      remoteData={remoteData}
      error={(error) => <GenericError error={error} />}
      loading=<Loading />
      reloading={null}
    >
      {([myProfile]) => {
        if (myProfile !== "not-found") {
          return <Loading />;
        }

        return <NotFound />;
      }}
    </RemoteDataView>
  );
};
